const updateDependentFieldValuesRecursively = (fields, currentField) => {
	let updatedField = {};
	let updatedFields = fields.map((field, index) => {
		if (field["is-dependent"] && field["dependent-key"] === currentField["field-name"]) {
			if (field.value) {
				let valueType = typeof field.value;
				if (valueType === "string") {
					field.value = "";
				} else if (valueType === "number") {
					field.value = null;
				} else if (valueType === "object" && Array.isArray(field.value)) {
					field.value = [];
				} else {
					field.value = {};
				}
			}
			updatedField = field;
		}
		return field;
	});
	if (Object.keys(updatedField).length > 0) {
		return updateDependentFieldValuesRecursively(updatedFields, updatedField);
	} else {
		return fields;
	}
};

export default updateDependentFieldValuesRecursively;
